import { REEL_NAME_MAX_LENGTH, STUDIO_COPY } from '../config';
import type { HighlightJob, ReelSummary } from '../api/types';

export { REEL_NAME_MAX_LENGTH };

/** Legacy stored sentinel — never show this on a public surface. */
export const UNTITLED_REEL_SENTINEL = 'Untitled reel';

function sanitizeReelNameText(raw: string): string {
  const collapsed = raw
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '');
  return collapsed.split(/\s+/).join(' ').trim();
}

export function normalizeReelName(raw: string | null | undefined): string {
  return sanitizeReelNameText(raw || '').slice(0, REEL_NAME_MAX_LENGTH);
}

export function isPlaceholderReelName(raw: string | null | undefined): boolean {
  const named = normalizeReelName(raw);
  return !named || named.toLowerCase() === UNTITLED_REEL_SENTINEL.toLowerCase();
}

export function isReelNameValid(raw: string | null | undefined): boolean {
  return !isPlaceholderReelName(raw);
}

export function publicReelTitle(raw: string | null | undefined): string {
  if (isPlaceholderReelName(raw)) {
    return STUDIO_COPY.publicReelFallback;
  }
  return normalizeReelName(raw);
}

export function reelNeedsName(
  reel: Pick<ReelSummary, 'reel_name' | 'needs_reel_name'> | Pick<HighlightJob, 'reel_name'>
): boolean {
  if ('needs_reel_name' in reel && reel.needs_reel_name) return true;
  return isPlaceholderReelName('reel_name' in reel ? reel.reel_name : null);
}

export function reelDisplayTitle(
  reel: Pick<ReelSummary, 'reel_name' | 'vod_title'> | Pick<HighlightJob, 'reel_name'>
): string {
  const named = normalizeReelName(
    'reel_name' in reel ? reel.reel_name : null
  );
  if (!isPlaceholderReelName(named)) return named;
  const legacy = normalizeReelName(
    'vod_title' in reel ? (reel as ReelSummary).vod_title : null
  );
  if (legacy && !isPlaceholderReelName(legacy)) return legacy;
  return STUDIO_COPY.publicReelFallback;
}
